import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { REVIEW_AVATARS } from "@temp/core/config";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";

var AvatarPicker = function AvatarPicker(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var intl = useIntl();
  var altMsg = intl.formatMessage({
    defaultMessage: "selected avatar",
    "id": "@next.components.atoms.AvatarPicker.AvatarPicker.251797872"
  });
  return React.createElement(S.Wrapper, null, React.createElement(S.Selected, {
    onClick: useCallback(function () {
      return setActive(function (s) {
        return !s;
      });
    }, [])
  }, React.createElement("img", {
    src: REVIEW_AVATARS.get(value),
    alt: altMsg
  }), !active && React.createElement(S.Pensile, null)), React.createElement(S.Options, {
    active: active
  }, React.createElement(S.OptionsInner, null, Array.from(REVIEW_AVATARS, function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    return React.createElement(S.Option, {
      key: key,
      selected: value === key,
      onClick: function onClick() {
        setActive(false);
        onChange(key);
      }
    }, React.createElement("img", {
      src: val,
      alt: key
    }));
  }))));
};

export { AvatarPicker };